import { render, staticRenderFns } from "./ValueCommercers.vue?vue&type=template&id=32013c95&scoped=true"
import script from "./ValueCommercers.vue?vue&type=script&lang=js"
export * from "./ValueCommercers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32013c95",
  null
  
)

export default component.exports